import { PackageVersionModule } from '@/pages/report/package/versions/types'
import packageVersionV1 from '@/pages/report/package/versions/v1'
import packageVersionV2 from '@/pages/report/package/versions/v2'

const packageVersions: Record<number, PackageVersionModule> = {
  1: packageVersionV1,
  2: packageVersionV2,
}

const getPackageVersion = (version: number): PackageVersionModule => {
  const packageVersion = packageVersions[version]

  if (!packageVersion) {
    throw new Error(`Версія пакета ${version} не підтримується`)
  }

  return packageVersion
}

export { getPackageVersion }
